var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-center gap-1.5 mt-1.5 text-xs leading-normal",class:_setup.stateClasses},[(_setup.resolvedIcon)?_c('fa',{staticClass:"h-3 w-3 flex-none",attrs:{"icon":_setup.resolvedIcon}}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_setup.parsedMessage)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }